// extracted by mini-css-extract-plugin
export const container = "Gallery-module--container--2CDOY";
export const partnerHeadline = "Gallery-module--partnerHeadline--3Mb54";
export const headerDescContainer = "Gallery-module--headerDescContainer--1KRig";
export const partnerList = "Gallery-module--partnerList--2ar-0";
export const partnerNote = "Gallery-module--partnerNote--1F8BV";
export const animationPartnerList = "Gallery-module--animation-partner-list--KVWUa";